/**
 * @file _form-cart.js
 */
'use strict';
import Common from '../../util/_common';

/**
 * @classname FormCart
 * @classdesc 会員情報編集フォーム
 */
export default class FormCart {
	/**
	 * @constructor
	 * @param {object} controller - コントローラー
	 */
	constructor(controller){
		this._controller = controller;
		this._conversionSymbol = '&hearts;' 
	};


	/**
	 * フォーム送信前処理
	 *
	 * @memberof Sample
	 * @return {undefined}
	 */
	preProcessing($form) {
		console.log('FormCart.preProcessing');
		// バリデーション前に行う処理を記載（開始）
	};


	/**
	 * フォーム送信後処理
	 *
	 * @memberof Sample
	 * @return {undefined}
	 */
	postProcessing($form) {
		console.log('FormCart.postProcessing');
		// バリデーション後に行う処理を記載（開始）

		// 受取日をYYYYMMDDの形式に変換
		if ($('#receiveDate').length > 0) {
			let receiveDate = $('#receiveDate').val();
			console.log(receiveDate);
			receiveDate = receiveDate.replace(/-/g, '');
			console.log(receiveDate);
			$('#receiveDate').val(receiveDate);
		}

		// メッセージのハートの絵文字置き換え処理
		const $optionDescription = $('#option_description');
		const $convertOptionDescription = $('#convert_option_description');
		// 商品詳細画面でのみチェック
		if ($optionDescription.length > 0) {
			const optionDescriptionValue = $optionDescription.val();
			let convertOptionDescription = optionDescriptionValue;
			let isConverted = false;
			// 絵文字置換の正規表現 
			// zwjを除外する
			let pattern = '(?<!\u{200D})'
			// 変換対象の絵文字のunicodeを記載
			pattern += '(?:\u{2764}\u{FE0F}|\u{1FA77}|\u{1F9E1}|\u{1F49B}|\u{1F49A}|\u{1F499}|\u{1FA75}|\u{1F49C}|\u{1F90E}|\u{1F5A4}|\u{1FA76}|\u{1F90D}|\u{2661}|\u{1F498}|\u{1F49D}|\u{1F496}|\u{1F497}|\u{1F493}|\u{1F49E}|\u{1F495}|\u{1F49F}|\u{2763}|\u{2665})';
			// zwjまたはバリアントセレクタで結合した絵文字を除外する
			pattern += '(?!(\u{200D}|\u{FE0F}\u{200D}))';
			const regex = new RegExp(pattern, 'ug');
			if (optionDescriptionValue.match(regex)) {
				isConverted = true;
				convertOptionDescription = convertOptionDescription.replace(regex, this._conversionSymbol)
			}
			if (isConverted) {
				// バリアントセレクタが残る場合があるため、削除する
				const variationSelectorsPattern = `${this._conversionSymbol}\u{FE0F}`;
				const variationSelectorsRegex = new RegExp(variationSelectorsPattern, 'ug');
				convertOptionDescription = convertOptionDescription.replace(variationSelectorsRegex, this._conversionSymbol);
				$convertOptionDescription.val(convertOptionDescription);
				console.log($convertOptionDescription.val());
			} else {
				$convertOptionDescription.val(optionDescriptionValue);
				console.log($convertOptionDescription.val());
			}
		}

		// バリデーション後に行う処理を記載（終了）
		this._controller.completePostProcessing($form);
	};
}
